//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import layout from '~/mixins/layout'
import { mobileBreakpoint } from '~/utils/breakpoints.js'

export default {
  mixins: [layout],
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    author: {
      type: Object,
      default() {},
    },
    image: {
      type: Object,
      default() {},
    },
    imageMobile: {
      type: Object,
      default() {},
    },
    tags: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      innerWidth: window.innerWidth,
    }
  },

  computed: {
    imageDependingOnDeviceWidth() {
      let src = this.image
      if (this.imageMobile && this.innerWidth <= mobileBreakpoint) {
        src = this.imageMobile
      }
      return this.backgroundImage(src)
    },
  },

  mounted() {
    window.addEventListener('resize', this.resizeCallback)
  },
  unMounted() {
    window.removeEventListener('resize', this.resizeCallback)
  },

  methods: {
    resizeCallback() {
      this.innerWidth = window.innerWidth
    },
  },
}
